import React from 'react';
import './BodySection.css';
import imagessection from '../../../Home/images/15 ACRES (2).jpg';
import STUDENT_PERFORMA_SCHOLARSHIP from "../bodysection/pdf/164813022248.pdf";
import STUDENT_SCHOLARSHIP_AFFIDAVIT from "./pdf/Affidavit___Student_-2023-1.docx"
import Application_For_Applying_Job from "./pdf/165509642339.pdf"
import imagessection1 from '../../images/WhatsApp Image 2025-05-01 at 08.43.36_129586b9.jpg'
// import imagessection2 from '../Section2/WhatsApp Image 2025-05-14 at 19.55.32_77dc393e.jpg'


const BodySection = () => {
  return (
    <div data-aos="fade-up" data-aos-duration="2000">
      <div>
        <div className='body-container2'>
          <div className='body-btn-section2'>
            <h2>Admissions 2025 : Admission Open for Diploma, UG & PG Courses for the Academic Year 2025-26.</h2>
            <img src={imagessection} alt="Admissions 2024 banner" className='imagessection' />
            <img src={imagessection1} alt="Admissions 2024 banner" className='imagessection' />
            {/* <img src={imagessection2} alt="Admissions 2024 banner" className='imagessection' /> */}
            <ul className='unorderlist'>
              <li><a href={Application_For_Applying_Job} download="Application_For_Applying_Job"><button className='btn'>Application For Applying Job</button></a></li>
              <li><a href={STUDENT_SCHOLARSHIP_AFFIDAVIT} download="STUDENT_PERFORMA_SCHOLARSHIP"><button className='btn'>STUDENT SCHOLARSHIP AFFIDAVIT</button></a></li>
              <li>
                <a href={STUDENT_PERFORMA_SCHOLARSHIP} download="STUDENT_PERFORMA_SCHOLARSHIP">
                  <button className='btn'>STUDENT PERFORMA SCHOLARSHIP</button>
                </a>
              </li> 
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BodySection;


